import React, { Component } from 'react'
import './NavigationBar.css'
import Dropdown from '../Dropdown/Dropdown'
import DropdownItem from '../DropdownItem/DropdownItem';
import {Link, NavLink} from "react-router-dom";

export default class NavigationBar extends Component {
  handleLogout = async () => {
    const log = confirm("Are you sure you want to logout?");
    if(!log) return;
    try {
      await fetch(`${process.env.REACT_APP_API_URL}/auth/logout`, {
        method: 'POST',
        credentials: 'include',
      });
    } catch {
      // proceed regardless
    }
    sessionStorage.removeItem('user');
    localStorage.removeItem('user');
    window.location.href='/';
  };

  render() {
    const { user } = this.props;
    const isNotUser = user && user.role_code !== 'user' && user.role_code !== 'User';

    return (
      <nav className='nav'>
        <ul>
            <li className='Verification'>
                <Dropdown buttonText="End User Verification" content = {
                <>
                  <DropdownItem>
                     <NavLink className='NavLink' to="/asset-draft">Asset Verification Draft</NavLink>
                  </DropdownItem>
                  {isNotUser && (
                    <DropdownItem>
                       <NavLink 
                         className='NavLink' 
                         to="/asset-report"
                       >
                         Asset Verification Report
                       </NavLink>
                    </DropdownItem>
                  )}
                </>
                }/>
            </li>
            <li className='Logout' onClick={this.handleLogout}>Logout</li>
        </ul>
      </nav>
    )
  }
}
